import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { SupervisorsService } from 'src/app/data/supervisors.service';

interface PagingRequest {
  SupervisorId: number;
  Page: number;
  PageSize: number;
  SortingDirection: string;
  SortingField: string;
}

@Injectable()
export class WorkerSubordinatesListDataSource {
  private supervisorsService = inject(SupervisorsService);

  subordinatesSubject = new Subject<PagingRequest>();
  subordinates$ = this.subordinatesSubject.pipe(
    switchMap((req) =>
      this.supervisorsService
        .getSupervisorSubordinates(req.SupervisorId, {
          Page: req.Page,
          Count: req.PageSize,
          SortingDirection: req.SortingDirection,
          SortingField: req.SortingField,
        })
        .pipe(
          tap((pagedRes) => this.count$.next(pagedRes.Count)),
          map((pagedRes) => pagedRes.Results),
        ),
    ),
  );
  count$ = new BehaviorSubject<number>(0);

  constructor() { }
}
